export type FilterBlock = {
  statement: "AND" | "OR";
  term: string;
  operator: FilterBlockOperator;
  value: string;
};

export type FilterTerm = {
  displayName: string;
  id: string | number;
  options: Array<string>;
};

export enum FilterBlockOperator {
  Equal = "Equal",
  Require = "Require",
  Exclude = "Excludes",
}
